"use strict";

exports.__esModule = true;
exports.EXPERIMENT_VIEW_COUNTERS_DISABLED_DEFAULT = exports.EXPERIMENT_BUSINESS_MANAGER_FILTERS = exports.EXPERIMENT_POSTPAGE_REVAMP = exports.EXPERIMENT_BUSINESS_MANAGER_STAGE2 = exports.EXPERIMENT_LINK_PREVIEW = exports.EXPERIMENT_RECENT_ACTIVITY_CATS = exports.EXPERIMENT_NEW_QA_KEYS = exports.EXPERIMENT_LOCAL_DRAFT = exports.EXPERIMENT_PAID_PLANS = void 0;
var EXPERIMENT_PAID_PLANS = 'specs.wixForum.PaidPlans';
exports.EXPERIMENT_PAID_PLANS = EXPERIMENT_PAID_PLANS;
var EXPERIMENT_LOCAL_DRAFT = 'specs.wixForum.LocalDraft';
exports.EXPERIMENT_LOCAL_DRAFT = EXPERIMENT_LOCAL_DRAFT;
var EXPERIMENT_NEW_QA_KEYS = 'specs.wixForum.NewQAKeys';
exports.EXPERIMENT_NEW_QA_KEYS = EXPERIMENT_NEW_QA_KEYS;
var EXPERIMENT_RECENT_ACTIVITY_CATS = 'specs.wixForum.RecentActivityCats';
exports.EXPERIMENT_RECENT_ACTIVITY_CATS = EXPERIMENT_RECENT_ACTIVITY_CATS;
var EXPERIMENT_LINK_PREVIEW = 'specs.wixForum.LinkPreview';
exports.EXPERIMENT_LINK_PREVIEW = EXPERIMENT_LINK_PREVIEW;
var EXPERIMENT_BUSINESS_MANAGER_STAGE2 = 'specs.wixForum.BusinessManagerStage2';
exports.EXPERIMENT_BUSINESS_MANAGER_STAGE2 = EXPERIMENT_BUSINESS_MANAGER_STAGE2;
var EXPERIMENT_POSTPAGE_REVAMP = 'specs.wixForum.PostPageRevamp';
exports.EXPERIMENT_POSTPAGE_REVAMP = EXPERIMENT_POSTPAGE_REVAMP;
var EXPERIMENT_BUSINESS_MANAGER_FILTERS = 'specs.wixForum.BusinessManagerFilters';
exports.EXPERIMENT_BUSINESS_MANAGER_FILTERS = EXPERIMENT_BUSINESS_MANAGER_FILTERS;
var EXPERIMENT_VIEW_COUNTERS_DISABLED_DEFAULT = 'specs.wixForum.ViewCountersDisabledDefault';
exports.EXPERIMENT_VIEW_COUNTERS_DISABLED_DEFAULT = EXPERIMENT_VIEW_COUNTERS_DISABLED_DEFAULT;